import { Paper, Title, Text, SimpleGrid } from "@mantine/core";

import { TInsuranceElement as IInsuranceElement } from "../../hooks/api/useGetInsuranceById";

import classes from "./index.module.css";

const EftElementComponent = ({ element }: { element: IInsuranceElement }) => (
  <Paper
    px={"lg"}
    py={{ base: "1rem", sm: "2rem" }}
    radius={"lg"}
    mb={"lg"}
    className={classes.insuranceListItemPaper}
  >
    <Title order={4} mb={0} ff={"var(--wallet-font-family-sambla-sans)"}>
      Efterlevandeskydd
    </Title>

    <SimpleGrid
      cols={{ base: 2, sm: 4 }}
      spacing={{ base: "md", sm: "lg" }}
      mt="xl"
    >
      <Text>
        <strong>Period:</strong>
      </Text>
      <Text>{element.paymentPeriod / 12} år</Text>
      <Text>
        <strong>Händelse:</strong>
      </Text>
      <Text>{element.eventType}</Text>
    </SimpleGrid>
  </Paper>
);

export default EftElementComponent;
